import { Component} from 'react'
import { Col, Container, Row } from 'reactstrap';
import HeadMobile from '../../../components/common/global_layout/carouselMobile';
import NavTabMobile from '../../../components/common/global_layout/navtabMobile';
import NavTab from "../../../components/common/global_layout/navTab2";
import CustomCard from '../../../components/common/customCard';
import AdvencedSearchVisas from '../../../components/common/Visas/advancedSearchVisas1'

class Visas extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return ( 
            <>
        <Container>
          <NavTab />
        </Container>

        <HeadMobile />

        <Container>
          <NavTabMobile 
            page="GHURFATY"
            width="150px"
           />
           <AdvencedSearchVisas />
           <center><h3>Recherchez Par Type De Visas</h3></center><br />
        </Container>
          <Container>
            <Col>
          <div className="custom-card cards-Vol">
                <Row>
                  <CustomCard
                    IdSpe="hg-ctrl-visa"
                    size={6}
                    imgPath={"/imgs/Visa/eVisa.png"}
                    linkPath={"/"}
                    title={"e-Visas"}
                    paddingCost={"0 10px 0 15px"}
                    isVisa={true}
                  />
                  <CustomCard
                    IdSpe="hg-ctrl-visa"
                    size={6}
                    imgPath={"/imgs/Visa/img2.png"}
                    linkPath={"/"}
                    title={"Visas Vignette"}
                    paddingCost={"0 15px 0 10px"}
                    isVisa={true}
                  />
                </Row>
                <Row className="second-cards-Vol">
                  <CustomCard
                    IdSpe="hg-ctrl-visa2"
                    size={4}
                    imgPath={"/imgs/Visa/img3.png"}
                    linkPath={"/"}
                    title={"Visas d'étude"}
                    paddingCost={"0 10px 0 15px"}
                    isVisa={true}
                  />
                  <CustomCard
                    IdSpe="hg-ctrl-visa2"
                    size={4}
                    imgPath={"/imgs/Visa/old.png"}
                    linkPath={"/"}
                    title={"Immigration"}
                    paddingCost={"0 10px 0 10px"}
                    isVisa={true}
                  />
                  <CustomCard
                    IdSpe="hg-ctrl-visa2"
                    size={4}
                    imgPath={"/imgs/Visa/world.png"}
                    linkPath={"/"}
                    title={"Visas Touristique"}
                    paddingCost={"0 15px 0 10px"}
                    isVisa={true}
                  />
                </Row>
              </div>
              <br /><br /><br />
              </Col>
          </Container>
          </>
         );
    }
}
 
export default Visas;